import { Component, Inject, OnInit } from '@angular/core';
import { DialogRef } from '../modal/dialog-ref';
import { DIALOG_DATA } from '../modal/dialog-tokens';
import { CoreLibModalComponent } from '../modal/modal.component';

enum Options {
  OPEN = 'OPEN',
  CANCEL = 'CANCEL',
}

export type ModalType = 'link' | 'qr';

@Component({
    selector: 'mh-core-lib-link-confirmation-modal',
    templateUrl: './link-confirmation-modal.component.html',
    styleUrls: ['./link-confirmation-modal.component.scss'],
    standalone: false
})
export class CoreLibLinkConfirmationModalComponent extends CoreLibModalComponent implements OnInit {
  linkName: string;
  url: string;
  modalType: ModalType = 'link';

  constructor(protected dialogRef: DialogRef, @Inject(DIALOG_DATA) public data: any) {
    super(dialogRef, data);
  }

  ngOnInit(): void {
    this.linkName = this.data?.linkName;
    this.url = this.data?.url;
    this.modalType = this.data?.modalType || 'link';
  }

  handleCancelClick() {
    this.close(Options.CANCEL);
  }

  handleConfirmClick() {
    this.close(Options.OPEN);
  }
}
